import { Params, ResultDto, abortableFetch } from '@eas/common-web';
import { TreeObject } from '@models';

export function getLocalTreeParams(): Params {
  return {
    size: -1,
    sort: [
      {
        field: 'hierarchicalOrder',
        order: 'ASC',
        type: 'FIELD',
      },
    ],
  };
}

export function fetchLocalTree<OPTION extends TreeObject>(url: string) {
  return abortableFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(getLocalTreeParams()),
  }).json() as Promise<ResultDto<OPTION>>;
}
